import { render, staticRenderFns } from "./PurchasesModuleMenu.vue?vue&type=template&id=68c28f1c&"
import script from "./PurchasesModuleMenu.vue?vue&type=script&lang=js&"
export * from "./PurchasesModuleMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports